import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { Vega } from 'react-vega';
import { Handler } from 'vega-tooltip';
import { useTranslation } from "react-i18next";
import seedrandom from 'seedrandom';

import className from "./style.module.scss";

export function VegaPlot(props) {

    const {
        t,
        // i18n
    } = useTranslation("translation");

    const DEFAULT_PLOT_MAX_WIDTH = 500;

    const [plotSpec, setPlotSpec] = useState(props.plotData.plotSpec);
    let plotData = [];
    let plotAltTextData = {};
    const [plotWidth, setPlotWidth] = useState(plotSpec.width);
    const [plotHeight, setPlotHeight] = useState(plotSpec.height);
    const [altTextParams, setAltTextParams] = useState({});

    useEffect(() => {

        // Dynamic vega plot size support issues mean we need custom logic
        setPlotSize();
        window.addEventListener("resize", setPlotSize);
        return () => {
            window.removeEventListener("resize", setPlotSize);
        };
    }, []);

    useEffect(() => {
        updatePlotData();
    }, [props.controlData]);

    const updatePlotData = () => {
        const seedVar = Math.random();
        
        if (props.preview === true) {
            if (props.plotData.plotFunctionTxt !== "") {
                let funcString = props.plotData.plotFunctionTxt.replace("(controlData)", "(controlData)");
                funcString = funcString.replace(new RegExp("const updateFunc =", "g"), "");
                funcString = funcString.replace(new RegExp("export default updateFunc;", "g"), "");
                funcString = funcString.replace(new RegExp("<br/>", "g"), " ");
                const func = eval(funcString);
                plotData = func({...props.controlData, seedVar: seedVar, seedrandom: seedrandom });
            }
        }
        else {
            plotData = props.plotCalculation({...props.controlData, seedVar: seedVar, seedrandom: seedrandom });
        }
        updatePlotSpec();

        if (props.preview === true) {
            if (props.plotData.altTextFunctionTxt !== "") {
                let funcString = props.plotData.altTextFunctionTxt.replace("(controlData)", "(controlData)");
                funcString = funcString.replace(new RegExp("const updateFunc =", "g"), "");
                funcString = funcString.replace(new RegExp("export default updateFunc;", "g"), "");
                funcString = funcString.replace(new RegExp("<br/>", "g"), " ");
                const func = eval(funcString);
                plotAltTextData = func({...props.controlData, seedVar: seedVar, seedrandom: seedrandom });
                setAltTextParams(plotAltTextData);
            }
        }
        else {
            setAltTextParams(props.altTextCalculation({...props.controlData, seedVar: seedVar, seedrandom: seedrandom }));
        }
    };

    const updatePlotSpec = () => {
        const updatedPlotSpec = plotSpec;
        updatedPlotSpec.data[0].values = plotData
        setPlotSpec({ ...updatedPlotSpec });
    };

    const setPlotSize = () => {
        const width = plotSpec.width;
        const height = plotSpec.height;
        const aspectRatio = width / height;
        const elem = document.getElementById(`plot_${props.plotData.title}`);

        let newWidth = parseFloat(elem.offsetWidth) - 40;
        let newHeight = ((parseFloat(elem.offsetWidth) - 40) / aspectRatio);

        if (newWidth > (plotSpec.maxWidth || DEFAULT_PLOT_MAX_WIDTH)) {
            newWidth = (plotSpec.maxWidth || DEFAULT_PLOT_MAX_WIDTH) - 40;
            newHeight = (((plotSpec.maxWidth || DEFAULT_PLOT_MAX_WIDTH) - 40) / aspectRatio);
        }

        setPlotWidth(newWidth);
        setPlotHeight(newHeight);
    };

    const renderDevFeatures = () => {
        return (
            <div className={className.Debug}>
                <div>
                    Alt-text: <br />
                    {t(`${props.plotData.altText}.string`, altTextParams)}
                </div>
                {props.plotData.recordURL !== undefined ?
                    <button onClick={() => { window.open(props.plotData.recordURL, "_blank") }}>
                        Airtable record
                    </button>
                    : null}
            </div>
        )
    };

    return (
        <div
            id={`plot_${props.plotData.title}`}
            className={className.PlotContainer}
            style={{
                aspectRatio: plotSpec.width / plotSpec.height,
                width: "calc(100% - 20px)",
                maxWidth: `calc((50vh*${(plotSpec.width / plotSpec.height)}) - 40)`,
            }}
        >
            <h4 className="viz-title">{t(`${props.plotData.title}.string`)}</h4>
            <div aria-label={props.plotData.altText !== "" ? t(`${props.plotData.altText}.string`, altTextParams) : ""}>
                <Vega spec={plotSpec} data={plotData} tooltip={new Handler().call} width={plotWidth} height={plotHeight} />

                {props.dev === true ?
                    renderDevFeatures()
                    : null}
            </div>
        </div>
    );
}

VegaPlot.propTypes = {
    plotData: PropTypes.shape({
        title: PropTypes.string.isRequired,
        plotFunction: PropTypes.string.isRequired,
        plotSpec: PropTypes.object.isRequired
    }).isRequired,
    controlData: PropTypes.object,
    // plotCalculation: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    widgetID: PropTypes.number.isRequired,
    dev: PropTypes.bool,
};
VegaPlot.defaultProps = {
    controlData: {},
    dev: false,
};
